import $ from "jquery";

const ACTIVE_CLASS = "show";
const PREVENT_SCROLL_CLASS = "prevent-scroll";
const HERO_VIDEO_BLOCK_SELECTOR = ".hero-block";
const HERO_PLAYER_SELECTOR = ".hero-video-embed-block__player";
const HERO_VIDEO_PLAY_TRIGGER_SELECTOR = "[data-hero-video-trigger]";
const HERO_VIDEO_STOP_TRIGGER_SELECTOR = "[data-hero-video-close-trigger]";

export class HeroVideoModule {
    constructor() {
        this.scrollPos = 0;
        this.setupEvents();
    }

    setupEvents() {
        $("body").on("click", HERO_VIDEO_PLAY_TRIGGER_SELECTOR, ev => {
            const $target = $(ev.currentTarget);
            const $parent = $target.closest(HERO_VIDEO_BLOCK_SELECTOR);
            const $videoPlayer = $parent.find(HERO_PLAYER_SELECTOR);

            this.showVideo($videoPlayer);
            console.log($target);
            console.log($parent);
            console.log($videoPlayer);
        });

        $("body").on("click", HERO_VIDEO_STOP_TRIGGER_SELECTOR, ev => {
            const $target = $(ev.currentTarget);
            const $parent = $target.closest(HERO_VIDEO_BLOCK_SELECTOR);
            const $videoPlayer = $parent.find(HERO_PLAYER_SELECTOR);

            this.closeVideo($videoPlayer);
        });
    }

    showVideo($player) {
        this.scrollPos = $(document).scrollTop();

        $player.addClass(ACTIVE_CLASS);
        $("body").addClass(PREVENT_SCROLL_CLASS);
    }

    closeVideo($player) {
        $player.removeClass(ACTIVE_CLASS);
        $player.replaceWith($player.prop("outerHTML"));

        $("body").removeClass(PREVENT_SCROLL_CLASS);

        if (this.scrollPos) {
            $(document).scrollTop(this.scrollPos);
        }
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/front/App/HeroVideoModule.js